import { gql } from '@apollo/client'
import { Heading, Separator, Subtitle } from '@farol-ds/react'
import { removeHTMLTags } from '@jusbrasil-web/docview/core'
import { ReactNode } from 'react'

import { MotionHeader_DocumentFragment } from './__generated__/motion-header.graphql'
import styles from './motion-header.module.scss'

export interface MotionHeaderProps {
  document: MotionHeader_DocumentFragment
  toolbar: ReactNode
}

export function MotionHeader(props: MotionHeaderProps) {
  const { document, toolbar } = props
  const title = removeHTMLTags(document.title || '')
  const subtitle = removeHTMLTags(document.subtitle || '')

  return (
    <div className={styles.header}>
      <div className={styles.titleWrapper}>
        <Heading size="2xl" asChild>
          <h1 dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>
        {subtitle && (
          <Subtitle asChild>
            <p dangerouslySetInnerHTML={{ __html: subtitle }} />
          </Subtitle>
        )}
      </div>

      {toolbar}
      <Separator className={styles.separator} />
    </div>
  )
}

MotionHeader.fragments = {
  document: gql`
    fragment MotionHeader_document on Document {
      title
      subtitle
    }
  `,
}
